export default __webpack_public_path__ + "static/mobile-chat-751f27320fea016544f3c15c4c3e5054.png";